import { FC } from 'react';
import { Stack } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldCheckbox from './FieldCheckbox';

const AttendanceDays: FC = () => {
    return (
        <>
            <Subtitle title="Osallistumispäivät" />
            <Stack gap="sm">
                <FieldCheckbox name="osallistumisToPe" label="perjantai - lauantai" />
                <FieldCheckbox name="osallistumisPeLa" label="lauantai - sunnuntai" />
            </Stack>
        </>
    );
};

export default AttendanceDays;
